// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nfc-page {
    width: 100vw;
    height: 100vh;
    background: transparent;
    color: #EAE0C8;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    font-family: 'Cinzel', serif;
}

@supports (height: 100dvh) {
    .nfc-page {
        height: 100dvh;
    }
}

.nfc-background-layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    z-index: -2;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    pointer-events: none;
}

.nfc-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
}

.nfc-header {
    width: 100%;
    padding: 20px;
    padding-top: 40px;
    /* Safe area for mobile status bar */
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    z-index: 10;
}

.nfc-pill {
    background: rgba(213, 190, 155, 0.24);
    border: none;
    border-radius: 30px;
    padding: 0.6rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: rgba(213, 190, 155, 1);
    backdrop-filter: blur(5px);
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'CormorantSC-Regular', serif;
    letter-spacing: 0.08em;
    isolation: isolate;
    position: relative;
}

.nfc-pill::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 30px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.nfc-pill:hover {
    background: rgba(213, 190, 155, 0.35);
    transform: translateY(-1px);
}

.nfc-pill.user-logged-in {
    padding: 0.6rem;
    cursor: default;
}

.nfc-pill.user-logged-in:hover {
    background: rgba(213, 190, 155, 0.24);
    transform: none;
}

.nfc-pill img {
    width: 16px;
    height: 16px;
}

.nfc-pill.coin-balance {
    background: rgba(0, 0, 0, 0.9);
    cursor: default;
}

.nfc-pill.coin-balance:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: none;
}

.nfc-content {
    flex: 1 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 5;
}

/* Scanning UI */
.scanning-ui {
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: pulseText 2s infinite ease-in-out;
}

.scan-card-icon {
    position: relative;
    width: 60px;
    height: 90px;
    margin-bottom: 40px;
}

.scan-card-outline {
    width: 100%;
    height: 100%;
    border: 2px solid #EAE0C8;
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.2);
}

.scan-sparkle {
    font-size: 24px;
    color: #EAE0C8;
    animation: spin 3s linear infinite;
}

.scan-card-outline.offset-1 {
    transform: rotate(-15deg) translateX(-10px);
    opacity: 0.6;
}

.scan-card-outline.offset-2 {
    transform: rotate(15deg) translateX(10px);
    opacity: 0.6;
}

.scan-text {
    text-align: center;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 1.6;
    opacity: 0.8;
    text-transform: uppercase;
    max-width: 80%;
}

/* Animating Card */
.animating-card-container {

    position: absolute;
    width: 240px;
    /* Mobile size */
    height: 400px;
    perspective: 1000px;
    transition: all 1s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 20;

    /* Initial state: Hidden below screen */
    bottom: -100%;
    left: 50%;
    transform: translateX(-50%);
}

.animating-card-container.scanning {
    bottom: -100%;
}

.animating-card-container.sliding {
    bottom: 70%;
    transform: translateX(-50%) translateY(50%);
    /* Center it */
}

.animating-card-container.flipping,
.animating-card-container.result {
    bottom: 70%;
    transform: translateX(-50%) translateY(50%);
}

.animating-card-container.result .card-face {
    transition: box-shadow 0.5s ease;
}

.animating-card-container.result:not(.reversed) .card-face {
    box-shadow: 0 0 0px #AFC6FFB2, 0 0 60px #AFC6FFB2;
}

.animating-card-container.result.reversed .card-face {
    box-shadow: 0 0 0px #FFB48AB2, 0 0 60px #FFB48AB2;
}

.animating-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

.animating-card-container.flipping .animating-card-inner,
.animating-card-container.result .animating-card-inner {
    transform: rotateY(180deg);
}

/* Reversed State */
.animating-card-container.result.reversed .animating-card-inner {
    transform: rotateY(180deg) rotateZ(180deg);
}

.card-face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-face img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-front {
    transform: rotateY(180deg);
    background: #000;
}

/* Result Text */
.result-text {
    position: absolute;
    bottom: 30%;
    text-align: center;
    z-index: 15;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.result-button {
    position: absolute;
    bottom: 18%;
    text-align: center;
    z-index: 15;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.toggle-instruction {
    font-size: 12px;
    color: #EAE0C8;
    opacity: 0.7;
    letter-spacing: 1px;
    margin-bottom: 10px;
    animation: pulseText 2s infinite;
}

.result-text h3 {
    color: #00ffcc;
    /* Cyan/Greenish like the image */
    font-family: 'Courier New', monospace;
    /* Looks like the font in image */
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 20px;
    text-shadow: 0 0 10px rgba(0, 255, 204, 0.5);
    margin: 0 0 5px 0;
}

.card-status {
    font-size: 14px;
    color: #EAE0C8;
    opacity: 0.9;
    margin: 0;
    font-weight: bold;
}

.fade-in {
    animation: fadeIn 1s ease-in forwards;
    opacity: 0;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulseText {

    0%,
    100% {
        opacity: 0.6;
    }

    50% {
        opacity: 1;
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.card-status {
    display: block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.card-status.upright {

    color: #AFC6FFB2;
}

.card-status.reversed {
    color: #FFB48AB2;
}

.confirm-btn {
    background: rgba(213, 190, 155, 0.24);
    border: none;
    border-radius: 30px;
    padding: 0.6rem 1.5rem;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: rgba(213, 190, 155, 1);
    backdrop-filter: blur(5px);
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'Urbanist-Regular', sans-serif;
    letter-spacing: 0.08em;
    isolation: isolate;
    position: relative;
    white-space: nowrap;
}

.confirm-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 30px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.confirm-btn:hover {
    background: rgba(213, 190, 155, 0.35);
    transform: translateY(-1px);
}

.confirm-btn:active {
    transform: translateY(0);
}

/* Mobile Responsive */
@media (max-width: 480px) {
    .animating-card-container {
        width: 200px;
        height: 333px;
    }

    .scan-card-icon {
        width: 50px;
        height: 75px;
        margin-bottom: 30px;
    }

    .nfc-header {
        padding-top: 30px;
        padding: 15px;
    }

    .nfc-pill {
        padding: 0.4rem 0.8rem;
        font-size: 12px;
        gap: 5px;
    }

    .nfc-pill img {
        width: 14px;
        height: 14px;
    }

    .nfc-pill.language-btn {
        padding: 0.4rem 0.6rem;
    }

    .header-right-group {
        gap: 6px;
    }
}

/* Header right group */
.header-right-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.nfc-pill.language-btn {
    padding: 0.6rem 1rem;
    cursor: pointer;
}

.lang-icon {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 0.05em;
    color: rgba(213, 190, 155, 1);
}

.lang-zh {
    font-size: 0.7rem;
}

/* Language Selection Modal */
.language-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    backdrop-filter: blur(10px);
}

.language-modal-content {
    background: rgba(30, 25, 20, 0.95);
    border: 1px solid rgba(212, 175, 55, 0.3);
    border-radius: 20px;
    padding: 40px;
    text-align: center;
    max-width: 350px;
    width: 90%;
    animation: fadeIn 0.3s ease;
    font-family: 'Urbanist-Regular'
}

.language-modal-content h2 {
    color: #EAE0C8;
    font-size: 20px;
    margin-bottom: 30px;
    font-weight: 400;
}

.language-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.language-options button {
    background: rgba(212, 175, 55, 0.15);
    border: 1px solid rgba(212, 175, 55, 0.4);
    border-radius: 12px;
    padding: 16px 24px;
    color: #EAE0C8;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Urbanist-Regular'
}

.language-options button:hover {
    background: rgba(212, 175, 55, 0.3);
    border-color: rgba(212, 175, 55, 0.6);
    transform: translateY(-2px);
}

/* Daily Reward Modal */
.daily-reward-modal {
    background: linear-gradient(135deg, rgba(40, 35, 25, 0.98) 0%, rgba(25, 20, 15, 0.98) 100%);
    border: 2px solid rgba(212, 175, 55, 0.5);
}

.daily-reward-modal h2 {
    font-size: 24px;
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 20px;
}

.daily-reward-message {
    color: #D5BE9B;
    font-size: 18px;
    margin-bottom: 30px;
    font-family: 'Urbanist-Regular'
}

.daily-reward-claim-btn {
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    border: none;
    border-radius: 12px;
    padding: 16px 40px;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Urbanist-Regular', sans-serif;
}

.daily-reward-claim-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.4);
}`, "",{"version":3,"sources":["webpack://./src/nfc/NfcRead.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;;IAEb,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;;IAEI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gDAAgD;IAChD,WAAW;;IAEX,uCAAuC;IACvC,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,qCAAqC;IACrC,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;;QAEI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,2CAA2C;IAC3C,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;IACI,2FAA2F;IAC3F,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD","sourcesContent":[".nfc-page {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: transparent;\r\n    color: #EAE0C8;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n    font-family: 'Cinzel', serif;\r\n}\r\n\r\n@supports (height: 100dvh) {\r\n    .nfc-page {\r\n        height: 100dvh;\r\n    }\r\n}\r\n\r\n.nfc-background-layer {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n\r\n    z-index: -2;\r\n    background-size: 100% 100%;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    pointer-events: none;\r\n}\r\n\r\n.nfc-page::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    z-index: 1;\r\n}\r\n\r\n.nfc-header {\r\n    width: 100%;\r\n    padding: 20px;\r\n    padding-top: 40px;\r\n    /* Safe area for mobile status bar */\r\n    display: flex;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    z-index: 10;\r\n}\r\n\r\n.nfc-pill {\r\n    background: rgba(213, 190, 155, 0.24);\r\n    border: none;\r\n    border-radius: 30px;\r\n    padding: 0.6rem 1.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 14px;\r\n    color: rgba(213, 190, 155, 1);\r\n    backdrop-filter: blur(5px);\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    letter-spacing: 0.08em;\r\n    isolation: isolate;\r\n    position: relative;\r\n}\r\n\r\n.nfc-pill::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 30px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.nfc-pill:hover {\r\n    background: rgba(213, 190, 155, 0.35);\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.nfc-pill.user-logged-in {\r\n    padding: 0.6rem;\r\n    cursor: default;\r\n}\r\n\r\n.nfc-pill.user-logged-in:hover {\r\n    background: rgba(213, 190, 155, 0.24);\r\n    transform: none;\r\n}\r\n\r\n.nfc-pill img {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n.nfc-pill.coin-balance {\r\n    background: rgba(0, 0, 0, 0.9);\r\n    cursor: default;\r\n}\r\n\r\n.nfc-pill.coin-balance:hover {\r\n    background: rgba(0, 0, 0, 0.9);\r\n    transform: none;\r\n}\r\n\r\n.nfc-content {\r\n    flex: 1;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n    z-index: 5;\r\n}\r\n\r\n/* Scanning UI */\r\n.scanning-ui {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    animation: pulseText 2s infinite ease-in-out;\r\n}\r\n\r\n.scan-card-icon {\r\n    position: relative;\r\n    width: 60px;\r\n    height: 90px;\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.scan-card-outline {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 2px solid #EAE0C8;\r\n    border-radius: 8px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.scan-sparkle {\r\n    font-size: 24px;\r\n    color: #EAE0C8;\r\n    animation: spin 3s linear infinite;\r\n}\r\n\r\n.scan-card-outline.offset-1 {\r\n    transform: rotate(-15deg) translateX(-10px);\r\n    opacity: 0.6;\r\n}\r\n\r\n.scan-card-outline.offset-2 {\r\n    transform: rotate(15deg) translateX(10px);\r\n    opacity: 0.6;\r\n}\r\n\r\n.scan-text {\r\n    text-align: center;\r\n    font-size: 14px;\r\n    letter-spacing: 1px;\r\n    line-height: 1.6;\r\n    opacity: 0.8;\r\n    text-transform: uppercase;\r\n    max-width: 80%;\r\n}\r\n\r\n/* Animating Card */\r\n.animating-card-container {\r\n\r\n    position: absolute;\r\n    width: 240px;\r\n    /* Mobile size */\r\n    height: 400px;\r\n    perspective: 1000px;\r\n    transition: all 1s cubic-bezier(0.25, 1, 0.5, 1);\r\n    z-index: 20;\r\n\r\n    /* Initial state: Hidden below screen */\r\n    bottom: -100%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.animating-card-container.scanning {\r\n    bottom: -100%;\r\n}\r\n\r\n.animating-card-container.sliding {\r\n    bottom: 70%;\r\n    transform: translateX(-50%) translateY(50%);\r\n    /* Center it */\r\n}\r\n\r\n.animating-card-container.flipping,\r\n.animating-card-container.result {\r\n    bottom: 70%;\r\n    transform: translateX(-50%) translateY(50%);\r\n}\r\n\r\n.animating-card-container.result .card-face {\r\n    transition: box-shadow 0.5s ease;\r\n}\r\n\r\n.animating-card-container.result:not(.reversed) .card-face {\r\n    box-shadow: 0 0 0px #AFC6FFB2, 0 0 60px #AFC6FFB2;\r\n}\r\n\r\n.animating-card-container.result.reversed .card-face {\r\n    box-shadow: 0 0 0px #FFB48AB2, 0 0 60px #FFB48AB2;\r\n}\r\n\r\n.animating-card-inner {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    transition: transform 0.8s;\r\n    transform-style: preserve-3d;\r\n}\r\n\r\n.animating-card-container.flipping .animating-card-inner,\r\n.animating-card-container.result .animating-card-inner {\r\n    transform: rotateY(180deg);\r\n}\r\n\r\n/* Reversed State */\r\n.animating-card-container.result.reversed .animating-card-inner {\r\n    transform: rotateY(180deg) rotateZ(180deg);\r\n}\r\n\r\n.card-face {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    backface-visibility: hidden;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);\r\n    border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.card-face img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.card-front {\r\n    transform: rotateY(180deg);\r\n    background: #000;\r\n}\r\n\r\n/* Result Text */\r\n.result-text {\r\n    position: absolute;\r\n    bottom: 30%;\r\n    text-align: center;\r\n    z-index: 15;\r\n    width: 100%;\r\n    padding: 0 20px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.result-button {\r\n    position: absolute;\r\n    bottom: 18%;\r\n    text-align: center;\r\n    z-index: 15;\r\n    width: 100%;\r\n    padding: 0 20px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.toggle-instruction {\r\n    font-size: 12px;\r\n    color: #EAE0C8;\r\n    opacity: 0.7;\r\n    letter-spacing: 1px;\r\n    margin-bottom: 10px;\r\n    animation: pulseText 2s infinite;\r\n}\r\n\r\n.result-text h3 {\r\n    color: #00ffcc;\r\n    /* Cyan/Greenish like the image */\r\n    font-family: 'Courier New', monospace;\r\n    /* Looks like the font in image */\r\n    text-transform: uppercase;\r\n    letter-spacing: 2px;\r\n    font-size: 20px;\r\n    text-shadow: 0 0 10px rgba(0, 255, 204, 0.5);\r\n    margin: 0 0 5px 0;\r\n}\r\n\r\n.card-status {\r\n    font-size: 14px;\r\n    color: #EAE0C8;\r\n    opacity: 0.9;\r\n    margin: 0;\r\n    font-weight: bold;\r\n}\r\n\r\n.fade-in {\r\n    animation: fadeIn 1s ease-in forwards;\r\n    opacity: 0;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(20px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes pulseText {\r\n\r\n    0%,\r\n    100% {\r\n        opacity: 0.6;\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.card-status {\r\n    display: block;\r\n    padding: 4px 12px;\r\n    border-radius: 12px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n}\r\n\r\n.card-status.upright {\r\n\r\n    color: #AFC6FFB2;\r\n}\r\n\r\n.card-status.reversed {\r\n    color: #FFB48AB2;\r\n}\r\n\r\n.confirm-btn {\r\n    background: rgba(213, 190, 155, 0.24);\r\n    border: none;\r\n    border-radius: 30px;\r\n    padding: 0.6rem 1.5rem;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 14px;\r\n    color: rgba(213, 190, 155, 1);\r\n    backdrop-filter: blur(5px);\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    letter-spacing: 0.08em;\r\n    isolation: isolate;\r\n    position: relative;\r\n    white-space: nowrap;\r\n}\r\n\r\n.confirm-btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 30px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.confirm-btn:hover {\r\n    background: rgba(213, 190, 155, 0.35);\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.confirm-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 480px) {\r\n    .animating-card-container {\r\n        width: 200px;\r\n        height: 333px;\r\n    }\r\n\r\n    .scan-card-icon {\r\n        width: 50px;\r\n        height: 75px;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    .nfc-header {\r\n        padding-top: 30px;\r\n        padding: 15px;\r\n    }\r\n\r\n    .nfc-pill {\r\n        padding: 0.4rem 0.8rem;\r\n        font-size: 12px;\r\n        gap: 5px;\r\n    }\r\n\r\n    .nfc-pill img {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n    .nfc-pill.language-btn {\r\n        padding: 0.4rem 0.6rem;\r\n    }\r\n\r\n    .header-right-group {\r\n        gap: 6px;\r\n    }\r\n}\r\n\r\n/* Header right group */\r\n.header-right-group {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.nfc-pill.language-btn {\r\n    padding: 0.6rem 1rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.lang-icon {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    font-weight: 500;\r\n    letter-spacing: 0.05em;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.lang-zh {\r\n    font-size: 0.7rem;\r\n}\r\n\r\n/* Language Selection Modal */\r\n.language-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 100;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.language-modal-content {\r\n    background: rgba(30, 25, 20, 0.95);\r\n    border: 1px solid rgba(212, 175, 55, 0.3);\r\n    border-radius: 20px;\r\n    padding: 40px;\r\n    text-align: center;\r\n    max-width: 350px;\r\n    width: 90%;\r\n    animation: fadeIn 0.3s ease;\r\n    font-family: 'Urbanist-Regular'\r\n}\r\n\r\n.language-modal-content h2 {\r\n    color: #EAE0C8;\r\n    font-size: 20px;\r\n    margin-bottom: 30px;\r\n    font-weight: 400;\r\n}\r\n\r\n.language-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.language-options button {\r\n    background: rgba(212, 175, 55, 0.15);\r\n    border: 1px solid rgba(212, 175, 55, 0.4);\r\n    border-radius: 12px;\r\n    padding: 16px 24px;\r\n    color: #EAE0C8;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    font-family: 'Urbanist-Regular'\r\n}\r\n\r\n.language-options button:hover {\r\n    background: rgba(212, 175, 55, 0.3);\r\n    border-color: rgba(212, 175, 55, 0.6);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* Daily Reward Modal */\r\n.daily-reward-modal {\r\n    background: linear-gradient(135deg, rgba(40, 35, 25, 0.98) 0%, rgba(25, 20, 15, 0.98) 100%);\r\n    border: 2px solid rgba(212, 175, 55, 0.5);\r\n}\r\n\r\n.daily-reward-modal h2 {\r\n    font-size: 24px;\r\n    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.daily-reward-message {\r\n    color: #D5BE9B;\r\n    font-size: 18px;\r\n    margin-bottom: 30px;\r\n    font-family: 'Urbanist-Regular'\r\n}\r\n\r\n.daily-reward-claim-btn {\r\n    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\r\n    border: none;\r\n    border-radius: 12px;\r\n    padding: 16px 40px;\r\n    color: #1a1a1a;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n}\r\n\r\n.daily-reward-claim-btn:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.4);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
